import { AbstractControl, ValidatorFn } from "@angular/forms";

export interface CodeTypeData {
  regexPattern?: RegExp;
  errorText: string;
  isinPrefix?: string;
  validatorFn?: ValidatorFn;
}

export const codeTypeData: { [key: string]: CodeTypeData } = {
  Valoren: {
    regexPattern: /^\d{9}$/,
    errorText: 'The Valoren code should consist of exactly 9 digits',
    isinPrefix: 'CH',
  },
  WKN: {
    regexPattern: /^[A-Za-z0-9]{6}$/,
    errorText: 'The WKN code should consist of 6 alphanumeric characters',
    isinPrefix: 'DE',
  },
  CUSIP: {
    regexPattern: /^[A-Za-z0-9]{9}$/,
    errorText: 'The CUSIP code should consist of 9 alphanumeric characters',
    isinPrefix: 'US',
  },
  'Common Code': {
    regexPattern: /^\d{9}$/,
    errorText: 'The Common Code should consist of exactly 9 digits',
    isinPrefix: 'XS',
  },
  Sedol: {
    errorText: 'The Sedol code should consist of 7 alphanumeric characters, starting with a letter between B-Z, and must not contain vowels. For more information, visit the <a href="https://www.isin.net/sedol/" target="_blank">Sedol official documentation</a>',
    validatorFn: (control: AbstractControl) => {
      if (control.pristine) {
        return null;
      }

      const { value } = control;
      const sedol = value?.toUpperCase() || "";

      // Sedols must not contain vowels, and although not specified in the ticket (COR-2378), 
      // according to the Sedol documentation, the first character must be a letter between B and Z.
      if (!sedol.trim().length || /[AEIOUY]+/.test(sedol) || !/^[B-Z][0-9B-Z]{6}/.test(sedol)) {
        return { invalidSedol: true };
      }

      const firstSedolPart = sedol.split('').slice(0, -1);
      const weightings = [1, 3, 1, 7, 3, 9, 1];
      const sum = firstSedolPart.reduce((acc, char, index) => acc + (parseInt(char, 36) * weightings[index]), 0);
      const checkDigit = (10 - (sum % 10)) % 10;

      return `${firstSedolPart.join('')}${checkDigit}` !== value ? { invalidSedol: true } : null;
    }
  }
};

export function getValidationForCodeType(codeType: string): CodeTypeData {
  return codeTypeData[codeType] ?? null;
}
